import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation CreateChat($participants: [String!]!) {
    createChat(participants: $participants) {
      success
      message
      id
    }
  }
`

export interface CreateChatInput {
  participants: string[]
}

export interface CreateChatOutput {
  createChat: {
    success: boolean
    message: string
    id: string
  }
}

export const useCreateChat = () => useMutation<CreateChatOutput, CreateChatInput>(mutation)
